import { useSuspenseQuery } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type SEAAccountFeatureConfigsResponse =
  paths['/accounts/{accountId}/feature-configs']['get']['responses']['200']['content']['application/json'];

export type AccountFeatureName = SEAAccountFeatureConfigsResponse['data']['featureConfigs'][0]['name'];

const fetchAccountFeatureConfigs = async (accountId: string | null) => {
  // If there is no account id returned from the user details, return null for account config information
  if (!accountId) {
    return null;
  }

  // Fetch the account feature configuration details for the primary account of the currently logged in user
  return await apiClient
    .get(`api/supplier-experience/accounts/${accountId}/feature-configs`)
    .json<SEAAccountFeatureConfigsResponse>();
};

export default function useFetchAccountFeatureConfigs(accountId: string | null) {
  return useSuspenseQuery({
    queryKey: ['account-feature-configs', accountId],
    queryFn: () => fetchAccountFeatureConfigs(accountId),
    select: (data) => data?.data,
  });
}
